import { createFileRoute } from "@tanstack/react-router";

import { Navigate } from "@/lib/router-compat";
export const Route = createFileRoute("/_public/policies/cancellation")({
  component: () => <Navigate to="/cancellation-policy" replace />,
});
